document.addEventListener('DOMContentLoaded', function () {
  const predictiveSearchContainer = document.querySelector('[data-predictive-search]');
  if (!predictiveSearchContainer) return;

  const searchInput = predictiveSearchContainer.querySelector('[data-predictive-search-input]');
  const resultsContainer = predictiveSearchContainer.querySelector('[data-predictive-search-results]');

  let debounceTimer;
  let currentRequest;

  function debounce(func, wait) {
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(debounceTimer);
        func(...args);
      };
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(later, wait);
    };
  }

  function noResults() {
    // resultsContainer.innerHTML = '<div class="predictive-search__loading">No articles found in AYMES Academy</div>';
    hideResults();
  }

  function showResults() {
    resultsContainer.classList.add('predictive-search__results--visible');
  }

  function hideResults() {
    resultsContainer.classList.remove('predictive-search__results--visible');
  }

  function showLoading() {
    resultsContainer.innerHTML = '<div class="predictive-search__loading">Searching...</div>';
    showResults();
  }

  async function performSearch(query) {
    if (query.length < 2) {
      hideResults();
      return;
    }

    // Cancel previous request
    if (currentRequest) {
      currentRequest.abort();
    }

    showLoading();

    const controller = new AbortController();
    currentRequest = controller;

    try {
      // First try: Standard predictive search
      const response = await fetch(
        `https://aymes-academy.onrender.com/articles/${encodeURIComponent(
          query
        )}`,
        {
          signal: controller.signal,
        }
      );

      if (!response.ok) throw new Error("Search failed");

      const data = await response.json();
      // console.log('Search API Response:', data);

      const articles = data || [];

      if (articles.length === 0) {
        noResults();
      } else {
        displayResults(articles);
      }

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Search error:', error);
        hideResults();
      }
    }
  }

  function displayResults(articles) {
    console.log('displayResults called with:', articles);



    // Limit to exactly 12 results
    const limitedArticles = articles.slice(0, 6);

    const gridItems = limitedArticles
      .map((article) => {
        // Use the correct fields from Shopify API
        const excerpt = article.summary_html || article.body || '';
        // Strip HTML tags and truncate
        const cleanExcerpt = excerpt.replace(/<[^>]*>/g, '').trim();
        const truncatedExcerpt = cleanExcerpt ? cleanExcerpt.substring(0, 100) + '...' : '';
        const imageUrl = article.image.src || '';
        const url = `/blogs/aymes-academy/${article.handle}`;

        return `
      <a href="${url}" class="predictive-search__item">
        ${
          imageUrl
            ? `<img src="${imageUrl}" alt="${article.title}" class="predictive-search__item-image" loading="lazy">`
            : '<div class="predictive-search__item-image" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999; font-size: 10px;">No Image</div>'
        }
        <div class="predictive-search__item-content">
          <h4 class="predictive-search__item-title">${article.title}</h4>
          ${truncatedExcerpt ? `<p class="predictive-search__item-excerpt">${truncatedExcerpt}</p>` : ''}
        </div>
      </a>
    `;
      })
      .join('');

    const currentQuery = searchInput.value.trim();
    const searchUrl = `/search?q=${encodeURIComponent(currentQuery)}&type=article&view=academy`;

    resultsContainer.innerHTML = `
    <div class="predictive-search__grid">
      ${gridItems}
    </div>
    <div class="predictive-search__view-all">
      <a href="${searchUrl}" class="esc-button">
        View all
      </a>
    </div>
  `;

    showResults();
  }

  // Event listeners
  searchInput.addEventListener(
    'input',
    debounce((e) => {
      performSearch(e.target.value.trim());
    }, 300)
  );

  searchInput.addEventListener('focus', () => {
    if (searchInput.value.trim().length >= 2) {
      showResults();
    }
  });

  // Hide results when clicking outside
  document.addEventListener('click', (e) => {
    if (!predictiveSearchContainer.contains(e.target)) {
      hideResults();
    }
  });

  // on submit
  predictiveSearchContainer.addEventListener('submit', (e) => {
    e.preventDefault();
    const searchUrl = `/search?q=${encodeURIComponent(searchInput.value.trim())}&type=article&view=academy`;
    window.location.href = searchUrl;
  });

  // Handle keyboard navigation
  searchInput.addEventListener('keydown', (e) => {
    const items = resultsContainer.querySelectorAll('.predictive-search__item');
    const viewAllButton = resultsContainer.querySelector('.predictive-search__view-all-button');
    const currentFocus = document.activeElement;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (items.length > 0) {
        if (currentFocus === searchInput) {
          items[0].focus();
        } else {
          const currentIndex = Array.from(items).indexOf(currentFocus);
          if (currentIndex < items.length - 1) {
            items[currentIndex + 1].focus();
          } else if (viewAllButton) {
            viewAllButton.focus();
          }
        }
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (currentFocus === viewAllButton) {
        if (items.length > 0) {
          items[items.length - 1].focus();
        } else {
          searchInput.focus();
        }
      } else if (items.length > 0) {
        const currentIndex = Array.from(items).indexOf(currentFocus);
        if (currentIndex > 0) {
          items[currentIndex - 1].focus();
        } else {
          searchInput.focus();
        }
      }
    } else if (e.key === 'Escape') {
      hideResults();
      searchInput.blur();
    }
  });
});
